import * as React from 'react'
import { ShopifyNext } from '@dotdev/next-components'
import { GlobalProps } from 'types'
import * as Snippets from 'snippets'
import { trackPromotionClick } from 'helpers'
import { Tracing } from 'trace_events'

export class CareImageWithCTA extends React.PureComponent<CareImageWithCTA.Props, CareImageWithCTA.State> {
  public static sectionId = 'careima';

  public render(): JSX.Element {
    const { section } = this.props
    const { settings } = section

    if (!settings) {
      return <React.Fragment />
    }

    return (
      <section className={'dynamic-care-image-with-CTA'} style={{ background: settings.background }}>
        <div className={'max-w-8xl px-1-6 md:2-4 2xl:px-20-8 mx-auto py-3-2 lg:py-2'}>
          <div className={'flex flex-wrap -mx-0-8 md:-mx-2-4'}>
            {section.blocks?.map(block => {
              const { settings } = block      
              const textSize = {
                'small': "text-l md:text-xl" ,
                'medium': "text-xl md:text-2xl",
                "large": "text-xl md:text-3xl"}[settings.headingtextsize] || "text-xl md:text-2xl"
              return (
                <div 
                  key={block.id} 
                  className={`w-1/2 px-0-8 md:px-2-4 ${settings.linkurl ? 'cursor-pointer': ''}`}
                  onClick={() => trackPromotionClick(
                    [{
                      id: section.id,
                      name: settings.title,
                      creative: 'Image title'
                    }],
                    settings.linkurl
                  )}
                >
                  <div className={'w-full relative'}>
                    <Snippets.Image
                      alt={settings.imagealttext || settings.title || 'care image with CTA'}
                      title={settings.imagealttext || settings.title || 'care image with CTA'}
                      className={'bg-cover bg-center absolute inset-0 h-full'}
                      ratio={'2:3'}
                      src={settings.image}
                      preventLazy={true}
                    />
                  </div>
                  <div className={'w-full px-0 md:px-1-6 pt-2-4 pb-4 md:py-4 text-center flex items-center justify-center text-black'}>
                    <div className={'-mx-4'}>
                      <Snippets.Heading
                        tag={'h2'}
                        className={`mb-0-11 ${textSize} leading-none uppercase`}
                      >
                        {settings.title}
                      </Snippets.Heading>

                      {settings.linktext ? (
                        <Snippets.Link
                          onClick={() => trackPromotionClick(
                            [{
                              id: section.id,
                              name: settings.title,
                              creative: 'Image title'
                            }],
                            settings.linkurl
                          )}
                          className={`block md:w-auto uppercase tracking-wide ${settings.linkurl ? 'cursor-pointer': ''} ${settings.bold ? 'font-bold' : ''} ${settings.underline ? 'underline' : ''}`}
                          title={settings.linktext}
                        >
                          {settings.linktext}
                        </Snippets.Link>
                      ) : null}
                    </div>
                  </div>
                </div>)
            })}
          </div>
        </div>
      </section>
    )
  }
}

export namespace CareImageWithCTA {
  export type Options = ShopifyNext.Section<{
    title: any;
    fullwidth: boolean;
    background: string;
    position: string;
    colour: string;
    image: string;
    imagealttext: string;
    content: string;
    linktext: string;
    linkurl: string;
    bold: boolean;
    underline: boolean;
    imageurl: string;
    headingtextsize: string;
  }>;
  export interface Props extends GlobalProps {
    section: CareImageWithCTA.Options;
  }
  export interface State { }
}
